//system
export const API_IP = '/ip';
export const API_FP = '/fp';
export const API_TIME = '/time';

//Auth
export const API_AUTH_LOGIN = '/auth/signin';
export const API_AUTH_CLIENT_SIGNIN = '/auth/client-signin';

//Users
export const API_USERS_TOKEN = '/users/token';
export const API_USERS_NEW88_CHECK = '/predictions/many';
export const API_USERS_SHBET_CHECK = '/users/shbet/check';

//Match
export const API_MATCHS = '/matchs';
export const API_MATCHS_DATE = '/matchs/date';
export const API_MATCHS_BY_DATE = '/match/match-date';
export const API_MATCHS_LIST = '/match/list-match';
export const API_MATCHS_RESULT_LIST = '/match/getMatchResultList';
export const API_PLAYERS = '/players';
export const API_TEAMS = '/teams';
export const API_WORLD_CUP_TEAMS_YELLOW_CARD = '/worldcup/teams-yellow-card';
export const API_WORLD_CUP_TEAMS_YELLOW_CARD_VOTE = '/worldcup/teams-yellow-card';
export const API_WORLD_CUP_TEAMS_FIRST_RED_CARD_VOTE = '/worldcup/first-redcard-team';
export const API_WORLD_CUP_TEAMS_CHAMPIONS = '/worldcup/teams-champions';
export const API_WORLD_CUP_TOP_SCORER_PREDICTIONS = '/worldcup/top-scorer-predictions';
export const API_WORLD_CUP_BEST_PLAYER_PREDICTIONS = '/worldcup/best-player-predictions';
export const API_WORLD_CUP_TEAMS_ELIMINATED_FIRST = '/worldcup/teams-eliminated-first';
export const API_WORLD_CUP_FINAL_ASIA_TEAM = '/worldcup/final-asia-team';
export const API_WORLD_CUP_TEAMS_ROUND16_FIRST = '/worldcup/teams-round16-first';
export const API_WORLD_CUP_TEAMS_ROUND32_FIRST = '/worldcup/teams-round32-first';
export const API_WORLD_CUP_FIRST_RED_CARD = '/worldcup/first-red-card';
export const API_WORLD_CUP_CHAMPION_VOTE = '/worldcup/champion';
export const API_WORLD_CUP_ELIMINATED_FIRST_VOTE = '/worldcup/eliminated-first';
export const API_WORLD_CUP_ROUND32_FIRST_VOTE = '/worldcup/round32-first';
export const API_WORLD_CUP_ROUND16_FIRST_VOTE = '/worldcup/round16-first';
export const API_WORLD_CUP_FINAL_ASIA_TEAM_VOTE = '/worldcup/final-asia-team';
export const API_WORLD_CUP_FIRST_REDCARD_TEAM_VOTE = '/worldcup/first-redcard-team';
export const API_WORLD_CUP_TOP_SCORER_VOTE = '/worldcup/top-scorer';
export const API_WORLD_CUP_BEST_PLAYER_VOTE = '/worldcup/best-player';
export const API_WORLD_CUP_HISTORY_PREDICTIONS_ACCOUNT = '/worldcup/history-predictions-account';
export const API_WORLD_CUP_CLAIM_REWARD = '/worldcup/claim-reward';

//Prediction
export const API_PREDICTIONS = '/predictions';
export const API_PREDICTIONS_MANY = '/predictions/many';
export const API_PREDICTIONS_GET = '/predictions/get';
export const API_PREDICTIONS_CLAIM = '/predictions/claim-reward';

//Settings
export const API_SETTINGS = '/settings';

//Banner
export const API_BANNER = '/banner';
//LUONGSONTV
export const API_MATCH_SCHEDULE = 'match-schedule';

//Files
export const API_FILES = '/file';

//Lottery APIs
export const API_LOTTERY = '/lottery';
export const API_LOTTERY_PREDICT_CREATE = '/lottery-predict/create';
export const API_LOTTERY_PREDICT_RESULT = '/lottery-predict/result';
export const API_LOTTERY_PREDICT_HISTORY = '/lottery-predict/account';
